import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./InterviewPerformance.module.css";
import { Link } from "react-router-dom";
import { Chip, Paper, styled } from "@mui/material";
import DatePickerSample from "../../../DatePicker";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import { R_PER_PAGE } from "../../../../../labels";
import { Search } from "@mui/icons-material";
import moment from "moment";
import ViewIcon from "../../BookModule/AdminSide/BookTabs/ViewIcon.png";

function InterviewPerformance({
  isLoading,
  setIsLoading,
  initialfields,
  handleChange,
  handleSort,
  reportData,
  handleFilterSearch,
  handleFilterSubjectSearch,
  handleFilterTestTopicSearch,

  setSelectedEvent,
  interviewMode,
  interview_mode,
  handleCheckboxChange,
  updateChipData,
  handleApplyFilter,
  selectedCategory,
  selectedTestTopics,
  setselectedStatus,
  selectedStatus,
  intCategory,
  handleFilter,
  setSelectedSubject,
  setSelectedTestTopics,
  selectedToppics,
  testTopics,
  settestTopics,
  dateFilter,
  handleDateFilterChange,
  setIsopen,
  isOpen,
  setAppData,
  appData,
  handleDelete,
  handleAllClear,
  handleClearOn,

  handleChangeDate,
  setAppOn, // Keep only one instance of setAppOn
  appOn,
  batchId,
  batchType,
  activeTab,
  handleView,
  searchTerm,
  setSearchTerm,
  handleSearch,
  handleSearchFocus,
  txtBSearch,
}) {
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));
  const filterRef_category = useRef(null);
  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);
  const filterTestTopicRef = useRef(null);
  const filterRef_course = useRef(null);
  const txtBSearch_course = useRef(null);
  const filterInterviewRef = useRef(null);
  const filterRefss = useRef(null);
  const [expandedId, setExpandedId] = useState(null);
  const [test_topics, setTest_topics] = useState([]);
  const [mediums, setMedium] = useState([]);
  const [ssubject, setSsubject] = useState([]);
  const [ssubjects, setSsubjects] = useState(ssubject);
  const [ssubjectsFiltered, setSsubjectsFiltered] = useState(ssubjects);
  const [testTopicsFiltered, setTestTopicsFiltered] = useState(testTopics);
  const [course_on, setCourse_on] = useState([]);
  const [courseIds, setCourseIds] = useState([]);
  const [courseId, setCourseId] = useState([]);
  const [subjectId, setSubjectId] = useState([]);
  const [subjectIds, setSubjectIds] = useState([]);
  const [branch_location_name, set_branch_location_name] = useState([]);
  const [branch, setBranch] = useState([]);
  const txtBSearch_subj = useRef(null); //search icon
  const [statusOn, setStatusOn] = useState([]);

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };
  let page = R_PER_PAGE;
  const [category_on, setCategory_on] = useState([]);
  const [categoryId, setCategoryId] = useState([]);
  const [ranges, setRanges] = useState([30, 60]);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  const handleFilterCourseSearch = (event, names) => {
    if (names == "course") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = courseId.filter(
          (item) =>
            item.course_name &&
            item.course_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setCourseIds(matchingObjects);
      } else {
        setCourseIds(courseId);
      }
    } else if (names == "subject") {
      const searchInput = event.target.value;
      if (searchInput !== "") {
        const matchingObjects = subjectId.filter(
          (item) =>
            item.subject_name &&
            item.subject_name.toLowerCase().includes(searchInput.toLowerCase())
        );
        // Do something with the matchingObjects, such as updating state or displaying them in the UI
        setSubjectIds(matchingObjects);
      } else {
        setSubjectIds(subjectId);
      }
    }
  };
  const handleFilterSearchFocus = (name) => {
    if (name == "course") {
      if (txtBSearch_course.current) {
        txtBSearch_course.current.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_course.current.dispatchEvent(event);
      }
    } else if (name == "subject") {
      if (txtBSearch_subj.current) {
        txtBSearch_subj.current.focus();
        // Create a new KeyboardEvent
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          keyCode: 13,
          which: 13,
          code: "Enter",
          bubbles: true,
        });
        // Dispatch the event
        txtBSearch_subj.current.dispatchEvent(event);
      }
    }
  };

  const generateCSVData = () => {
    const headers = [
      "S.No",
      "Class Name",
      "Date",
      "Subject",
      "Test Topic",
      "Status",
    ];
    const rows = [];
    let serialNumber = 1;

    currentData.forEach((item) => {
      if (item.type === "single_exam") {
        rows.push([
          serialNumber++,
          item.event_name || "",
          item.start_date
            ? new Date(item.start_date).toLocaleDateString("en-GB")
            : "",
          item.subject?.map((subj) => subj.subject).join(", ") || "",
          item.test_topic?.map((topic) => topic.test_topic).join(", ") || "",
          item.status === 1 ? "Completed" : "Absent",
        ]);
      } else if (item.type === "combined_exam") {
        // Add parent row for combined exam
        rows.push([
          serialNumber++,
          item.exam_name || "",
          "", // No date for parent
          "", // No subject for parent
          "", // No test topic for parent
          "", // No status for parent
        ]);

        // Add child rows for each exam in the combined exam
        item.exam_data?.forEach((child) => {
          rows.push([
            "", // Empty serial number for child rows
            child.event_name || "",
            child.start_date
              ? new Date(child.start_date).toLocaleDateString("en-GB")
              : "",
            child.subject?.map((subj) => subj.subject).join(", ") || "",
            child.test_topic?.map((topic) => topic.test_topic).join(", ") || "",
            child.status === 1 ? "Completed" : "Absent",
          ]);
        });
      }
    });

    return [headers, ...rows];
  };
  const generatePDF = () => {
    const headers = [
      "S.No",
      "Class Name",
      "Date",
      "Subject",
      "Test Topic",
      "Status",
    ];

    let serialNumber = 1;
    const rows = [];

    mergedData.forEach((item) => {
      if (item.type === "single_exam") {
        rows.push([
          serialNumber++,
          item.event_name ?? "-",
          item.start_date
            ? new Date(item.start_date).toLocaleDateString("en-GB")
            : "-",
          Array.isArray(item.subject)
            ? item.subject.map((s) => s.subject).join(", ")
            : "-",
          Array.isArray(item.test_topic)
            ? item.test_topic.map((t) => t.test_topic).join(", ")
            : "-",
          item.status === 1 ? "Completed" : "Absent",
        ]);
      } else if (item.type === "combined_exam") {
        // Add parent combined exam row
        rows.push([
          serialNumber++,
          item.exam_name ?? "-",
          "-",
          "-",
          "-",
          "-", // skip ranks and status
        ]);

        // Add child exams
        item.exam_data?.forEach((child) => {
          rows.push([
            "", // no serial for child
            child.event_name ?? "-",
            child.start_date
              ? new Date(child.start_date).toLocaleDateString("en-GB")
              : "-",
            Array.isArray(child.subject)
              ? child.subject.map((s) => s.subject).join(", ")
              : "-",
            Array.isArray(child.test_topic)
              ? child.test_topic.map((t) => t.test_topic).join(", ")
              : "-",
            child.status === 1 ? "Completed" : "Absent",
          ]);
        });
      }
    });

    // Navigate to preview page with table structure
    navigate("/preview", {
      state: {
        title: "Class Performance Data",
        headers,
        rows,
        filename: "ClassPerformance.pdf",
        autoPrint: true,
      },
    });
  };
  const filterEventNameRef = useRef(null);
  const filterDateRef = useRef(null);
  const filterSubjectRef = useRef(null);
  const filterStatusRef = useRef(null);
  const filterTotalMarksRef = useRef(null);
  const filterRef_branch_location = useRef(null);
  // Combine both arrays safely

  const mergedData = [...reportData];
  const totalRecords = mergedData.length;
  const totalPages = Math.ceil(totalRecords / rowsPerPage);
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = mergedData.slice(start, end);
  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };
  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     // ✅ Event Name
  //     if (
  //       filterEventNameRef.current &&
  //       !filterEventNameRef.current.contains(event.target) &&
  //       !event.target.closest(".react-datepicker")
  //     ) {
  //       const hasEventName = updateChipData.some(
  //         (chipItem) => chipItem.type === "interview_mode"
  //       );

  //       if (hasEventName) {
  //         const updatedEventName = updateChipData.filter(
  //           (chipItem) => chipItem.type === "interview_mode"
  //         );
  //         setSelectedEvent(updatedEventName);
  //       } else {
  //         setSelectedEvent([]);
  //       }

  //       setIsopen((prev) => ({ ...prev, interview_mode: false }));
  //     }

  //     // ✅ Date
  //     if (
  //       filterDateRef.current &&
  //       !filterDateRef.current.contains(event.target) &&
  //       !event.target.closest(".react-datepicker") &&
  //       !event.target.closest(".filterBoxOne_Con")
  //     ) {
  //       const dateChip = updateChipData.find(
  //         (chipItem) =>
  //           chipItem.type === "dayRange" || chipItem.type === "dateRange"
  //       );

  //       if (dateChip) {
  //         if (dateChip.type === "dayRange") {
  //           setAppData({
  //             FDate: "",
  //             TDate: "",
  //             Days: dateChip.Days,
  //             name: "",
  //           });
  //         } else {
  //           setAppData({
  //             FDate: dateChip.fdate,
  //             TDate: dateChip.edate,
  //             Days: "",
  //             name: "",
  //           });
  //         }
  //         setAppOn([dateChip]);
  //       } else {
  //         setAppData({
  //           FDate: "",
  //           TDate: "",
  //           Days: "",
  //           name: "",
  //         });
  //         setAppOn([]);
  //       }

  //       setIsopen((prev) => ({ ...prev, appliedOn: false }));
  //     }

  //     // ✅ Subject
  //     if (
  //       filterSubjectRef.current &&
  //       !filterSubjectRef.current.contains(event.target) &&
  //       !event.target.closest(".react-datepicker")
  //     ) {
  //       const hasSubject = updateChipData.some(
  //         (chipItem) => chipItem.type === "subject"
  //       );

  //       if (hasSubject) {
  //         const updatedSubject = updateChipData.filter(
  //           (chipItem) => chipItem.type === "subject"
  //         );
  //         setSelectedSubject(updatedSubject);
  //       } else {
  //         setSelectedSubject([]);
  //       }

  //       setIsopen((prev) => ({ ...prev, subject: false }));
  //     }

  //     // ✅ Test Topic
  //     if (
  //       filterTestTopicRef.current &&
  //       !filterTestTopicRef.current.contains(event.target) &&
  //       !event.target.closest(".react-datepicker")
  //     ) {
  //       const hasTestTopic = updateChipData.some(
  //         (chipItem) => chipItem.type === "testTopic"
  //       );

  //       if (hasTestTopic) {
  //         const updatedTestTopic = updateChipData.filter(
  //           (chipItem) => chipItem.type === "testTopic"
  //         );
  //         setSelectedTestTopics(updatedTestTopic);
  //       } else {
  //         setSelectedTestTopics([]);
  //       }

  //       setIsopen((prev) => ({ ...prev, testTopic: false })); // 👈 close popup
  //     }

  //     //  Status
  //     if (
  //       filterStatusRef.current &&
  //       !filterStatusRef.current.contains(event.target) &&
  //       !event.target.closest(".react-datepicker")
  //     ) {
  //       const hasStatus = updateChipData.some(
  //         (chipItem) => chipItem.type === "status"
  //       );

  //       if (hasStatus) {
  //         const updatedStatus = updateChipData.filter(
  //           (chipItem) => chipItem.type === "status"
  //         );
  //         setselectedStatus(updatedStatus);
  //       } else {
  //         setselectedStatus([]);
  //       }

  //       setIsopen((prev) => ({ ...prev, status: false }));
  //     }

  //     //  Total Marks
  //     if (
  //       filterTotalMarksRef.current &&
  //       !filterTotalMarksRef.current.contains(event.target) &&
  //       !event.target.closest(".react-datepicker")
  //     ) {
  //       setIsopen((prev) => ({ ...prev, tot_marks: false }));
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [updateChipData]);

  return (
    <div className={`container-fluid  global_container BathDet p-0`}>
      <div className="row ">
        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
          <div class="input-group">
            <input
              ref={txtBSearch}
              type="text"
              class={styles.Inputs}
              id="SearchInput"
              name="SearchInput"
              placeholder="Search by Class Names, Subject, Class Topics"
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
              onKeyDown={handleSearch}
            />
            <span
              class={styles.input_group_text}
              id="SearchInput"
              onClick={handleSearchFocus}
            >
              <span className="material-icons" onClick={handleSearchFocus}>
                search
              </span>
            </span>
          </div>
        </div>

        {/* <div className="col-md-8 col-12 ListBtn">
          <ul className="List-Button">
            <li class="ListBtnItems">
              <CustomDownloadButton
                csvListData={generateCSVData()}
                iconName=" file_download "
                filename={"TestPerfomance.csv"}
                csvName="  Download as CSV"
              />
            </li>
            <li class="ListBtnItems primaryButton" onClick={generatePDF}>
              <span className="material-icons me-1 align-middle text-white">
                file_download
              </span>
              Download as PDF
            </li>
          </ul>
        </div> */}
      </div>
      {updateChipData?.length > 0 ? (
        <div className="row mt-3">
          <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
            <Paper
              sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                listStyle: "none",
                p: 0.5,
                m: 0,
              }}
              component="ul"
            >
              {updateChipData.map((data, index) => {
                let icon;
                return (
                  <ListItem key={index}>
                    <Chip
                      icon={icon}
                      label={
                        <>
                          <span className={"BoldTyText"}>
                            {data.type === "price"
                              ? `Price: ${data.name}`
                              : data.name}
                          </span>
                        </>
                      }
                      onDelete={handleDelete(data, index)}
                    />
                  </ListItem>
                );
              })}
              <ListItem className="clearAll_list">
                <a
                  className="clearAll_listItem"
                  href="javascript:void(0)"
                  onClick={handleAllClear}
                >
                  Clear All Filters
                </a>
              </ListItem>
            </Paper>
          </div>
        </div>
      ) : (
        // No chips to show
        <div></div>
      )}
      <div className="row mt-2 mx-0">
        <div className="col-md-12 table-responsive tableMinHeight px-0">
          <table className="table" id="tableListHeader">
            <thead>
              <tr>
                {/* Class Name */}
                <th id="th" className={styles.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "serialNumber")}
                    className="textHead_th"
                  >
                    S.No.
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "serialNumber")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" className={styles.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "interview_title")}
                    className="textHead_th"
                  >
                    Interview Title
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "interview_title")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th">
                  <span className="text_th"> Interview Mode</span>{" "}
                  <span
                    className={`align-middle material-icons ${
                      interview_mode?.length > 0 || isOpen.interview_mode
                        ? styles.active_icons_book
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "interview_mode")}
                    style={{ cursor: "pointer" }}
                  >
                    filter_list
                  </span>
                  {isOpen.interview_mode === true && (
                    <div className="filterBoxs_testlist mt-3">
                      <div className="col-md-12 form-check filterStatus_list">
                        <ul className="ulFilterListData">
                          <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name={"Online"}
                              value={"1"}
                              checked={interview_mode.some((element) => {
                                if (element.id == "1") {
                                  return true;
                                }
                                return false;
                              })}
                              id={"Online"}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  e,
                                  "interview_mode",
                                  "interview_mode"
                                )
                              }
                            />
                            <label
                              className="form-check-label filterChipText_withoutBG "
                              htmlFor={"Online"}
                            >
                              Online
                            </label>
                          </li>
                          <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name={"ClassRoom"}
                              value={"0"}
                              checked={interview_mode.some((element) => {
                                if (element.id == "0") {
                                  return true;
                                }
                                return false;
                              })}
                              id={"ClassRoom"}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  e,
                                  "interview_mode",
                                  "interview_mode"
                                )
                              }
                            />
                            <label
                              className="form-check-label filterChipText_withoutBG "
                              htmlFor={"ClassRoom"}
                            >
                              ClassRoom
                            </label>
                          </li>
                        </ul>
                      </div>
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClearOn("interview_mode")}
                              className="secondaryButton "
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              disabled={
                                interview_mode.length === 0 ? true : false
                              }
                              onClick={() =>
                                handleApplyFilter("interview_mode")
                              }
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th">
                  <span className="text_th"> Category</span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "intCategory")}
                  >
                    import_export
                  </span>
                  <span
                    class={` align-middle material-icons  ${
                      selectedCategory?.length > 0 || isOpen.intCategory
                        ? styles.active_icons_book
                        : ""
                    }`}
                    onClick={(e) => handleFilter(e, "intCategory")}
                  >
                    filter_list
                  </span>
                  {isOpen.intCategory === true && (
                    <div className="filterBoxs p-1" ref={filterSubjectRef}>
                      <div className="filterBoxText ">
                        <hr />
                        {intCategory.map((el) => (
                          <div className="row mt-2 ">
                            <div className="col-md-12">
                              <div class="form-check ms-3">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  name={el.name}
                                  value={el.id}
                                  id={el.name}
                                  checked={selectedCategory.some((element) => {
                                    if (element.id == el.id) {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "intCategory")
                                  }
                                />
                                <label
                                  class="form-check-label "
                                  for="defaultCheck1"
                                  htmlFor={el.name}
                                >
                                  {el.name}
                                </label>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClearOn("intCategory")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("intCategory")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th" className={styles.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "interview_title")}
                    className="textHead_th"
                  >
                    Course
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "interview_title")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" className={styles.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "interview_title")}
                    className="textHead_th"
                  >
                    Location
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "interview_title")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" className={styles.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "interview_title")}
                    className="textHead_th"
                  >
                    Total Marks
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "interview_title")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" className={styles.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "interview_title")}
                    className="textHead_th"
                  >
                    Panel Mark
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "interview_title")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" className={styles.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "interview_title")}
                    className="textHead_th"
                  >
                    Slab Mark
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "interview_title")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th" className={styles.tableThPadding}>
                  <span
                    onClick={(e) => handleSort(e, "interview_title")}
                    className="textHead_th"
                  >
                    Rank
                  </span>
                  <span
                    onClick={(e) => handleSort(e, "interview_title")}
                    className={`textHead_th material-icons align-middle`}
                  >
                    import_export{" "}
                  </span>
                </th>
                <th id="th">
                  <span
                    onClick={() => handleSort("start_date")}
                    className="textHead_th px-1"
                  >
                    Date
                  </span>
                  <span
                    onClick={() => handleSort("start_date")}
                    className={`material-icons textHead_th align-middle`}
                  >
                    import_export
                  </span>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      handleFilter(e, "appliedOn");
                    }}
                    className={` textHead_th align-middle material-icons ${
                      (appData &&
                        Object.entries(appData).some(
                          ([key, val]) =>
                            key !== "name" &&
                            val !== null &&
                            val !== undefined &&
                            val.toString().trim() !== ""
                        )) ||
                      isOpen.appliedOn
                        ? styles.active_icons_book
                        : ""
                    }`}
                  >
                    filter_list
                  </span>

                  {isOpen.appliedOn === true && (
                    <div
                      className="filterBoxs_testlist mt-2 p-2"
                      ref={filterDateRef}
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        left: "10px",
                      }}
                    >
                      <div className="form-check p-1">
                        <label
                          htmlFor="startDate"
                          className="form-label confirm_value me-1"
                        >
                          From Date
                        </label>
                        <DatePickerSample
                          IconInput="LI_filterIocnBoxInputTest"
                          className="LI_FilterInputs"
                          name="FDate"
                          handleChange={handleChangeDate}
                          fieldInput={appData.FDate}
                          txtAdMDob={fDatePickerRef}
                        />
                      </div>

                      <div className="form-check p-1 mt-2">
                        <label
                          htmlFor="endDate"
                          className="form-label confirm_value me-1"
                        >
                          To Date{" "}
                          <span data-required="true" aria-hidden="true"></span>
                        </label>
                        <DatePickerSample
                          IconInput="LI_filterIocnBoxInputTest"
                          className="LI_FilterInputs"
                          name="TDate"
                          handleChange={handleChangeDate}
                          fieldInput={appData.TDate}
                          txtAdMDob={tDatePickerRef}
                          minDate={appData.FDate}
                        />
                      </div>

                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => handleClearOn("startDate")}
                              className="secondaryButton"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              onClick={() => handleApplyFilter("startDate")}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                      {/* <div className="borderWidth row row mt-2">
                                          <div className="col-md-4 col-4">
                                            <span
                                              className="clearFilter ms-2"
                                              onClick={() => handleClearOn("startDate")}
                                            >
                                              Clear
                                            </span>
                                          </div>
                                          <div className="col-md-8 col-8 text-end">
                                            <button
                                              className="primaryButton"
                                              onClick={handleApplyFilter}
                                            >
                                              Apply Filter2
                                            </button>
                                          </div>
                                        </div> */}
                    </div>
                  )}
                </th>
                {/* Status */}
                <th id="th">
                  <span
                    onClick={() => handleSort("status")}
                    className="textHead_th"
                  >
                    Status
                  </span>
                  <span
                    onClick={() => handleSort("status")}
                    className="textHead_th material-icons align-middle"
                  >
                    import_export
                  </span>
                  <span
                    className={`align-middle material-icons color-table ${
                      selectedStatus?.length > 0 || isOpen.status
                        ? styles.active_icons_book
                        : ""
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleFilter(e, "status")}
                  >
                    filter_list
                  </span>
                  {isOpen.status === true && (
                    <div
                      className="filterBoxs_testlist mt-2"
                      ref={filterStatusRef}
                    >
                      <div className="col-md-12 form-check filterStatus_list">
                        <ul className="ulFilterListData">
                          <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name="Absent"
                              value="0"
                              id="Absent"
                              checked={selectedStatus.some(
                                (el) => el.id === "0"
                              )}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setselectedStatus([
                                    { id: "0", name: "Absent", type: "status" },
                                  ]);
                                } else {
                                  setselectedStatus([]);
                                }
                              }}
                            />
                            <label
                              className="form-check-label filterChipText bg-green"
                              htmlFor="Absent"
                            >
                              Absent
                            </label>
                          </li>
                          <li className="filterListData">
                            <input
                              className="ListCheckbox"
                              type="checkbox"
                              name="Completed"
                              value="1"
                              id="Completed"
                              checked={selectedStatus.some(
                                (el) => el.id === "1"
                              )}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setselectedStatus([
                                    {
                                      id: "1",
                                      name: "Completed",
                                      type: "status",
                                    },
                                  ]);
                                } else {
                                  setselectedStatus([]);
                                }
                              }}
                            />
                            <label
                              className="form-check-label bg-orange filterChipText"
                              htmlFor="Completed"
                            >
                              Completed
                            </label>
                          </li>
                        </ul>
                      </div>
                      <div className="borderWidth row">
                        <ul className="List-Button">
                          <li className="ListBtnItems">
                            <Link
                              to={"javascript:void(0)"}
                              onClick={() => {
                                setselectedStatus([]);
                                handleClearOn("status");
                              }}
                              className="secondaryButton"
                            >
                              Clear
                            </Link>
                          </li>
                          <li className="ListBtnItems">
                            <Link
                              onClick={() => handleApplyFilter("status")}
                              className="primaryButton"
                            >
                              Apply Filter
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                </th>
                {/* Action */}
                <th id="th">
                  <span className="textHead_th">Action</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData && currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td id="td">{item.serialNumber}</td>
                    <td>{item.interview_title || "-"}</td>
                    <td>{item.interview_mode || "-"}</td>
                    <td>{item.category || "-"}</td>
                    <td>{item.course || "-"}</td>
                    <td>{item.location || "-"}</td>
                    <td>100</td>
                    <td>{item.panel_mark ?? 0}</td>
                    <td>{item.slab_mark ?? 0}</td>
                    <td>{item.event_rank ?? 0 ?? 0}</td>
                    <td>
                      {item.date
                        ? new Date(item.date).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                        : "-"}
                    </td>
                    <td>
                      {item.status === 1 ? (
                        <span className="filterChipText bg-orange mx-0">
                          Completed
                        </span>
                      ) : (
                        <span className="filterChipText bg-pink mx-0">
                          Absent
                        </span>
                      )}
                    </td>
                    <td>
                      <button
                        className={"view_icon_button"}
                        onClick={() =>
                          handleView(
                            item.event_pk,
                            item.batch_id,
                            item.status,
                            item.event_type,
                            item
                          )
                        }
                      >
                        <span className={`visibleicon material-icons`}>
                          visibility
                        </span>
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="13" style={{ textAlign: "center" }}>
                    No records to display
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="row mt-2">
        <Pagination
          rowsPerPage={rowsPerPage}
          handlePageCount={handlePageCount}
          startPage={totalRecords > 0 ? start + 1 : 0}
          endPage={totalRecords > 0 ? Math.min(end, totalRecords) : 0}
          totalRecords={totalRecords}
          handlePrev={() => handlePrev(currentPage - 1)}
          currentPrevPage={currentPage === 1}
          prevButton={`${styles.prev_button} ${styles.materialIconsRightAndLeft} me-2`}
          handleNext={() => handleNext(currentPage + 1)}
          currentNextPage={currentPage === totalPages || totalPages == 0}
        />
      </div>
    </div>
  );
}
export default InterviewPerformance;
